import { request } from "_utilities/request";
import { setCreatePassword, startCreatePassword } from "./slices/createPassword.slice";
import { setLogin, startLog } from "./slices/owner.slice";
import { setSignUp, startSignUp } from "./slices/signUp.slice";
import { setVerifyEmail, startVerifyEmail } from "./slices/verifyEmail.slice";
import { setWorkspaces, startWorkspaces } from "./slices/workspaces.slice";
import { API_URL } from "_config/constants/app.constants";
import { setForgot, startForgot } from "./slices";

/**
 * 
 * @returns 
 */
export const isLoggedIn = () => (dispatch) => {
  dispatch(startLog());
  request({
    baseUrl: API_URL,
    endpoint: "/auth/loggedin",
    type: "get",
    feedback: { error: false },
    params: {ts: Date.now()},
    withCredentials: true
  }).then((res) => {
    let { data } = res;
    if (!data?.[0]) data = null;
    dispatch(setLogin({ data: data?.[0] }));
  });
};

/**
 * 
 * @param { Object } post 
 * @param { Object } extras 
 * @returns 
 */
export const login = (post, extras = {}) => 
  async (dispatch) => {
    dispatch(startLog());
    let res = await request({
      baseUrl: API_URL,
      endpoint: "/auth/login",
      type: "post",
      data: post,
      withCredentials: true,
      ...extras
    }, { withCredentials: true });
    let { data, error } = res;
    dispatch(setLogin({ data, error }));
    return { data, error };
  };

/**
 * Cambia el workspace enlazado a la cookie de sesion.
 * POST /auth/login/workspace {workspaceId}
 * Actualiza el usuario en el store (owner) con el nuevo workspaceCurrent.
 * NO redirige: el redirect lo decide la vista segun {status,data,error}.
 *
 * @param { String } workspaceId
 * @param { Object } extras
 * @returns { Promise<{ data, error, status }> }
 */
export const loginWorkspace = (workspaceId, extras = {}) =>
  async (dispatch) => {
    dispatch(startLog());
    let res = await request({
      baseUrl: API_URL,
      endpoint: "/auth/login/workspace",
      type: "post",
      data: { workspaceId },
      withCredentials: true,
      ...extras
    });
    let { data, error, status } = res;
    dispatch(setLogin({ data, error }));
    return { data, error, status };
  };

/**
 * Lista los workspaces a los que el usuario esta enrolado.
 * GET /auth/workspaces?w={workspacesId:[...]}
 *
 * @param { Array } workspacesId  ids de workspace del usuario logueado
 * @param { Object } extras
 * @returns { Promise<{ data, error }> }
 */
export const fetchWorkspaces = (workspacesId, extras = {}) =>
  async (dispatch) => {
    dispatch(startWorkspaces());
    let res = await request({
      baseUrl: API_URL,
      endpoint: "/auth/workspaces",
      type: "get",
      params: { w: { workspacesId } },
      withCredentials: true,
      ...extras
    });
    let { data, error } = res;
    dispatch(setWorkspaces({ data, error }));
    return { data, error };
  };

/**
 *
 * @returns
 */
export const logout = () =>
  async (dispatch) => {
    dispatch(startLog());
    await request({
      baseUrl: API_URL,
      endpoint: "/auth/logout",
      type: "post"
    });
    dispatch(setLogin({ data: null }));
  };

/**
 * 
 * @param {Object} post 
 * @param {Object} extras 
 */
export const forgot = (post, extras = {}) => 
  async (dispatch) => {
    dispatch(startForgot());
    let res = await request({
      baseUrl: API_URL,
      endpoint: "/auth/forgot",
      type: "post",
      data: {
        ...post,
        reset: "password"
      },
      ...extras
    });
    let { data, error } = res;
    dispatch(setForgot({ data, error }));
    return { data, error };
  };

/**
 * 
 * @param {String} token 
 * @param {Object} post 
 * @param {Object} extras 
 * @returns 
 */
export const restorePassword = (token, post, extras = {}) =>
  async (dispatch) => {
    dispatch(startCreatePassword());
    let res = await request({
      baseUrl: API_URL,
      endpoint: `/auth/reset/access/${token}`,
      type: "post",
      data: post,
      ...extras
    });
    let { data } = res;
    dispatch(setCreatePassword({ data }));
  };
/**
 * 
 * @param { Object } params 
 * @param { Object } extras 
 * @returns 
 * 
 * body: {
 *  fork: String| "core", "gs1" ,
 *  email: String,
 *  [accountKey: String],
 *  [flags: Object {
 *    terms-condit: Bool | true,
 *    priv: Bool | true
 *  }]
 * }
 */
export const signUp = (post, extras = {}) => 
  async (dispatch) => {
    dispatch(startSignUp());
    let res = await request({
      endpoint: '/enrollment/signup',
      type: 'post',
      data: post,
      ...extras
    });
    let { data, error } = res;

    dispatch(setSignUp({ data: data?.[0], error }));
    return { data: data?.[0], error };
  };


/**
 * 
 * @param {*} data 
 * @param {*} extras 
 * @returns 
 * 
 * body: {
 *  email: String,
 *  code: String
 * }
 */
export const verifyEmail = (post, extras = {}) => 
  async (dispatch) => {
    dispatch(startVerifyEmail());
    let resp = await request({
      endpoint: "/enrollment/user/email-check",
      type: "post",
      data: post,
      ...extras
    });
    let { data, error } = resp;
    dispatch(setVerifyEmail({ data: data?.[0], error }));
    return { data, error };
  };

/**
 * 
 * @param { Object } data 
 * @param { Object } extras 
 * @returns 
 * 
 * body: {
 *  email: String,
 *  password: String
 * }
 */
export const createPassword = (post, extras = {}) =>
  async (dispatch) => {
    dispatch(startCreatePassword());
    let res = await request({
      endpoint: "/enrollment/user/password",
      type: "post",
      data: post,
      ...extras
    });
    let { data, error } = res;
    dispatch(setCreatePassword({ data, error }));
    return { data, error };
  };

